import axios from 'axios';
import { toast } from 'react-toastify';
const AxiosInstance = axios.create({
  baseURL: `${process.env.REACT_APP_API_BASE_URI}/api`,
});
AxiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  return config;
}, (error) => {
  return Promise.reject(error)
});
AxiosInstance.interceptors.response.use(async(response) => {
  return response.data;
}, (error) => {
  const mess = error?.response?.data?.message || error?.response?.data?.mess || error.message || ''
  if(mess==='Access Denied'){
    window.location.replace('/login')
    return
  }
  toast.error(mess, { toastId: 'apierror', position: 'top-center', autoClose: 4000 })
  return Promise.reject(error);
});
export default AxiosInstance